const convertStringToBase64 = (img: string) => {
    if (typeof img !== 'string') return '';

    return `data:image/png;base64, ${img}`;
};

export default {convertStringToBase64};
